module.exports = __webpack_public_path__ + "static/media/OnBoarding_banor_tpOnboardingCreateprofile.a55b2970.png";